import React, { PropsWithChildren } from 'react'
import { Box, SxStyleProp } from 'rebass'
import { ActionButton, IActionButton } from '../ActionButton/ActionButton'
import { TextV2, ICMSTextV2Props } from '../Text/TextV2'
import { HeadingWithSupportingCopy } from '../HeadingWithSupportingCopy/HeadingWithSupportingCopy'
import { ModuleSection, IModuleSectionProps } from '../ModuleSection/ModuleSection'
import { getBackgroundImageStyles, getContainerStyles, getOuterContainerStyles } from './Billboard.styles'

export interface IBillboardProps extends IModuleSectionProps {
  title?: ICMSTextV2Props
  body?: ICMSTextV2Props[]
  eyebrowText?: ICMSTextV2Props
  actionButton?: IActionButton
  copyLocation?: 'left' | 'right'
  textFullWidth?: boolean
  backgroundImage?: string
  mobileBackgroundImage?: string
  sx?: SxStyleProp
  headingChildren?: React.ReactElement | null
}

export const Billboard = ({
  title,
  body,
  eyebrowText,
  actionButton,
  copyLocation,
  backgroundImage,
  mobileBackgroundImage,
  textFullWidth,
  sx = {},
  dataTestId,
  headingChildren,
  children,
  ...moduleSectionProps
}: PropsWithChildren<IBillboardProps>) => {
  const isCopyRight = copyLocation === 'right'

  return (
    <ModuleSection
      {...moduleSectionProps}
      moduleSx={{
        ...getBackgroundImageStyles(backgroundImage, mobileBackgroundImage),
        ...(moduleSectionProps.moduleSx || {}),
      }}
      dataTestId={dataTestId}
    >
      <Box
        sx={{
          ...getOuterContainerStyles(isCopyRight),
          ...sx,
        }}
      >
        <Box sx={getContainerStyles(isCopyRight)}>
          {eyebrowText && (
            <TextV2
              tag={eyebrowText.tag}
              textFontStyle={eyebrowText.textFontStyle}
              textFontColor={eyebrowText.textFontColor}
              sx={{ marginBottom: '30px', textTransform: 'uppercase', ...eyebrowText.sx }}
              data-test-id={dataTestId}
            >
              {eyebrowText.text}
            </TextV2>
          )}
          <HeadingWithSupportingCopy
            title={{ ...title, sx: { marginBottom: '20px', ...(title ? title.sx : {}) } }}
            body={body}
            fullWidth={textFullWidth}
          />
          {headingChildren}
          {actionButton ? (
            <Box sx={{ width: ['100%', '100%', 235], marginTop: 30 }}>
              <ActionButton {...actionButton} />
            </Box>
          ) : null}
        </Box>
        <>{children}</>
      </Box>
    </ModuleSection>
  )
}
